/**
 * Created by samirguo on 15/12/25.
 * 统一管理页面中的tips, 默认查找所有 data-role="tips" 类型的trigger
 */

var cachedTips = {};
var initTips = function (config) {
    config = config || {};
    var triggerType = config.triggerType || "click";
    var arrowPosition = config.arrowPosition || 'lt';
    var cacheKey = triggerType + "@" + arrowPosition;

    var trigger = config.trigger || "[data-role=tips]";
    var triggers = trigger.split(',').map(function(item) { return item.trim(); });

    //初始值
    var initialTips = config.content || '';
    var initialWidth = config.width || '200';

    var cachedTip = cachedTips[cacheKey];
    var balloon = cachedTip && cachedTip.balloon;
    if(cachedTip) {
        var currentTriggers = cachedTip.triggers;
        var newTriggers = triggers.filter(function(item) {
            return currentTriggers.indexOf(item) === -1;
        });
        if(newTriggers.length > 0) {
            //有新加的, 将triggers添加到原来的,并且重新创建balloon
            triggers = currentTriggers.concat(newTriggers);
            trigger = triggers.join(',');
            balloon.destroy();
        } else {
            //重复添加, 直接返回balloon实例
            return balloon;
        }
    }

    balloon = new this({
        events: {
            'before:show': 'beforeShow'
        },
        trigger: trigger,
        triggerType: triggerType,
        arrowPosition: arrowPosition,
        inViewport: true,
        delegateNode: document,

        beforeShow: function() {
            var target = this.activeTrigger;
            this.set('width', target.data('width') || initialWidth);
            //目前动态设置arrowPosition是无效的,已经提issue 2016.01.04
            //this.set('arrowPosition', target.data('arrowPosition') || arrowPosition);
            this.set('content', target.data('tips') || initialTips);
        },
        content: initialTips
    });

    cachedTips[cacheKey] = {
        balloon: balloon,
        triggers: triggers
    };

    return balloon;
};

module.exports = initTips;
